export type RegisteredMobilePrimaryCTA = {
	defaultLabel: string;
	labelKey: string;
	path?: string[];
	url?: string;
	worker?: {
		id: string;
	};
};

export const shouldRenderMobilePrimaryCTA = ({
	cta,
	inLeague,
	pageID,
}: {
	cta: RegisteredMobilePrimaryCTA | undefined;
	inLeague: boolean | undefined;
	pageID: unknown;
}) => inLeague === true && cta !== undefined && pageID !== "leagueDashboard";
